// extracted by mini-css-extract-plugin
export var innerWrapper = "title-text-section-module--inner-wrapper--HtPhc";
export var text = "title-text-section-module--text--H941c";
export var title = "title-text-section-module--title--50sy7";